import { getShopperAgentTriggerCategoryLabel } from "@redotech/redo-merchant-marketing-app/common/shopper-agent/trigger-category-ui";
import { TriggerCategory } from "@redotech/redo-model/shopper-agent";
import { TRIGGERS_BY_CATEGORY } from "@redotech/redo-model/shopper-agent/triggers";
import {
  Layout,
  RedoCheckboxCard,
} from "@redotech/redo-web/arbiter-components/checkbox/redo-checkbox-card";
import { Text } from "@redotech/redo-web/text";
import type { Dispatch, SetStateAction } from "react";
import { memo } from "react";
import { ALL_CONCIERGE_TRIGGER_CATEGORIES } from "./helpers";
import { ScrollableStepLayout } from "./scrollable-step-layout";
import {
  getStaggeredContentRevealDelayMs,
  StepMotionItem,
} from "./step-motion";

export interface TriggerCategoriesStepProps {
  animateItems?: boolean;
  stepNumber: number;
  selectedCategories: TriggerCategory[];
  setSelectedCategories: Dispatch<SetStateAction<TriggerCategory[]>>;
}

export const TriggerCategoriesStep = memo(function TriggerCategoriesStep({
  animateItems,
  stepNumber,
  selectedCategories,
  setSelectedCategories,
}: TriggerCategoriesStepProps) {
  const title = "Choose when Concierge should reach out";

  return (
    <ScrollableStepLayout
      animateItems={animateItems}
      stepNumber={stepNumber}
      subtitle={
        <>
          We&apos;ll start with helpful customer moments turned on, like
          shipping questions, returns, and checkout help. Choose what Concierge
          should handle now, and you can update it anytime.
        </>
      }
      title={title}
    >
      {ALL_CONCIERGE_TRIGGER_CATEGORIES.map((category, index) => {
        const checked = selectedCategories.includes(category);
        const triggerCount = TRIGGERS_BY_CATEGORY[category].length;
        return (
          <StepMotionItem
            animateItems={animateItems}
            delayMs={getStaggeredContentRevealDelayMs(title, index)}
            key={category}
          >
            <RedoCheckboxCard
              checked={checked}
              inputType="checkbox"
              layout={Layout.LEFT}
              onClick={() =>
                setSelectedCategories((current) =>
                  current.includes(category)
                    ? current.filter((value) => value !== category)
                    : [...current, category],
                )
              }
              title={getShopperAgentTriggerCategoryLabel(category)}
            >
              <Text fontSize="xs" textColor="tertiary">
                {triggerCount} customer{" "}
                {triggerCount === 1 ? "moment" : "moments"}
              </Text>
            </RedoCheckboxCard>
          </StepMotionItem>
        );
      })}
    </ScrollableStepLayout>
  );
});
